// Availability rules derived from the /check_session response's
// `videos: { total, pending }`, `quick_turns: { total, pending }`,
// and `credits: { total, pending, minutes_per_credit, credit_based }`.
//
// null  → account has no quota configured at all (backend sends null)
// 0     → quota exists but fully consumed
// >0    → quota available

export const isQuickTurnNotConfigured = (quickTurnsPending) =>
  quickTurnsPending === null

export const isQuickTurnUnavailable = (quickTurnsPending) =>
  typeof quickTurnsPending === 'number' && quickTurnsPending <= 0

// Legacy video-count gate (credit_based: false)
export const isCreateProjectUnavailable = (videosPending) => videosPending === 0

// Credit gate (credit_based: true) — pending can go negative for overdrawn orgs
export const isCreateProjectUnavailableOnCredits = (creditsPending) =>
  typeof creditsPending === 'number' && creditsPending <= 0

// Combined gate: branches on credit_based flag from check_session
export const isCreateProjectUnavailableEffective = (videosPending, creditsPending, creditBased) =>
  creditBased
    ? isCreateProjectUnavailableOnCredits(creditsPending)
    : isCreateProjectUnavailable(videosPending)

// Mirrors Deals::CreditCalculator on the backend.
// videoLengthValue: the `value` from /options/video_length — SECONDS as a string.
// minutesPerCredit: video_length_mins / minutes_per_credit from check_session/dashboard.
export const creditsForVideo = (videoLengthValue, minutesPerCredit) => {
  const mins = Number(videoLengthValue || 0) / 60
  if (!minutesPerCredit || minutesPerCredit <= 0 || mins <= 0) return 1
  return Math.max(Math.ceil(mins / minutesPerCredit), 1)
}

export const QUICK_TURN_NOT_CONFIGURED_MESSAGE =
  "You do not have any quick turn project quota. Contact Lucihub."

export const QUICK_TURN_UNAVAILABLE_MESSAGE =
  "You've used all the 24-hour quick turns available under your current contract."

export const CREATE_PROJECT_UNAVAILABLE_MESSAGE =
  "You've used all the videos available under your current contract."

export const CREDITS_EXHAUSTED_MESSAGE =
  "Your video credits are exhausted for this contract."
